<template>
  <div :class="$style.base" data-pw="base-info">
    <BaseIcon icon="iconInfo" :class="$style.icon" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import BaseIcon from '~/base/components/icon/Icon.vue'
</script>

<style module>
.base {
  max-width: 270px;
  padding-left: 27px;
  margin: var(--space-xs) + ' 0 ' + var(--space-md);
  color: var(--color-pacificblue);
  font-size: clamp(14px, 2vw, 16px);
  line-height: clamp(17px, 2vw, 19px);
  letter-spacing: 0.01286em;
  display: flex;
  position: relative;
}

.icon {
    opacity: 0.5;
    position: absolute;
    left: 0;
}
</style>
